var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { orderBy, uniqBy } from 'lodash';
import { CATEGORY_GROUP_HIDDEN, DEFAULT_CATEGORY_GROUP_NAME, DEFAULT_CATEGORY_GROUP_NAME_ALTERNATIVE, DEFAULT_STUDENT_HOME_CATEGORY_GROUP_NAME, EXAM_EXIT_TYPE, EXAM_SPECIALTY_TYPE, NUMBER_ORDERING_REGEX, STUDENT_CATEGORY_GROUP } from 'reports/had/constants/had.constant';
export var screenModes = {
    desktop: 'desktop',
    ipad: 'ipad',
    mobile: 'mobile'
};
// ================= Category Common =========================
export var getCategoryGroupIdByName = function (categoryGroupList, categoryGroupName) {
    var _a, _b;
    var categoryGroupId = (_a = categoryGroupList === null || categoryGroupList === void 0 ? void 0 : categoryGroupList.find(function (categoryGroup) { return categoryGroup.examType === EXAM_EXIT_TYPE; })) === null || _a === void 0 ? void 0 : _a.categoryGroup.find(function (category) { return category.categoryGroupName === categoryGroupName; }).categoryGroupId;
    if (!categoryGroupId) {
        categoryGroupId = (_b = categoryGroupList === null || categoryGroupList === void 0 ? void 0 : categoryGroupList.find(function (categoryGroup) { return categoryGroup.examType === EXAM_SPECIALTY_TYPE; })) === null || _b === void 0 ? void 0 : _b.categoryGroup.find(function (category) { return category.categoryGroupName === categoryGroupName; }).categoryGroupId;
    }
    return categoryGroupId;
};
export var getUniqueStudentExamCategories = function (studentExamCategory) {
    return studentExamCategory.map(function (sec) {
        var exams = orderBy(sec.exams, ['dateTaken'], ['desc']);
        var uniqExams = uniqBy(exams, 'examId');
        return __assign(__assign({}, sec), { exams: uniqExams });
    });
};
// ================= CategoryWeakest =========================
export var NO_DATA_FOUND_RECOMMENDED_LEVEL_MESSAGE = 'All categories with more than 3 items are at the Recommended level';
export var REQUIRED_NUMBER_OF_ITEMS = 3;
export var NUMBER_OF_CATEGORY_DISPLAY = 3;
export var CATEGORY_SCORE_900 = 900;
export var getCategorySummaryByNumeralCondition = function (data, numberOfItems, numberOfCategoryDisplay, isUseScoreLessThan900) {
    if (data === void 0) { data = []; }
    var filteredData = isUseScoreLessThan900
        ? data.filter(function (category) { return category.totalNumberOfItems > numberOfItems && category.meanCategoryScore < CATEGORY_SCORE_900; })
        : data.filter(function (category) { return category.totalNumberOfItems > numberOfItems; });
    return filteredData
        .sort(function (category1, category2) { return category1.meanCategoryScore - category2.meanCategoryScore || category1.subCategoryChildName.localeCompare(category2.subCategoryChildName); })
        .slice(0, numberOfCategoryDisplay);
};
export var renderSubCategoryChildName = function (_a) {
    var subCategoryChildName = _a.subCategoryChildName;
    return subCategoryChildName === null || subCategoryChildName === void 0 ? void 0 : subCategoryChildName.replace(NUMBER_ORDERING_REGEX, '');
};
export var buildWeakestCategoryHeader = function (numberOfItems, renderMeanCategoryScore) {
    return [
        {
            title: "Categories with ".concat(numberOfItems, "+ items"),
            field: 'subCategoryChildName',
            align: 'left',
            customRender: renderSubCategoryChildName
        },
        {
            title: 'Mean Category Score',
            field: 'meanCategoryScore',
            align: 'right',
            customRender: renderMeanCategoryScore
        }
    ];
};
// ================= CategoryTable =========================
export var buildCategoryGroupOptions = function (categories, isStudentRole) {
    if (categories.length) {
        var totalCategories_1 = [];
        categories.forEach(function (item) {
            totalCategories_1 = __spreadArray(__spreadArray([], totalCategories_1, true), item.categoryGroup, true);
        });
        var totalCategoriesObject_1 = {};
        totalCategories_1.forEach(function (item) {
            if (!totalCategoriesObject_1[item.categoryGroupId]) {
                totalCategoriesObject_1[item.categoryGroupId] = item.categoryGroupName;
            }
        });
        var distinctCategories = Object.keys(totalCategoriesObject_1).map(function (item) { return ({ key: item, name: totalCategoriesObject_1[item] }); });
        var compareMenu = function (menu1, menu2) { return menu1.name.localeCompare(menu2.name); };
        var finalCategoriesGroup = distinctCategories.filter(function (item) { return !CATEGORY_GROUP_HIDDEN.includes(item.name); });
        if (isStudentRole) {
            finalCategoriesGroup = distinctCategories.filter(function (item) { return STUDENT_CATEGORY_GROUP.includes(item.name); });
        }
        return finalCategoriesGroup.sort(compareMenu);
    }
    return [];
};
export var getDefaultCategoryGroupId = function (categoryGroupOptions, isStudentRole) {
    var _a;
    if (categoryGroupOptions.length) {
        if (isStudentRole) {
            var _b = categoryGroupOptions.find(function (group) { return group.name === DEFAULT_STUDENT_HOME_CATEGORY_GROUP_NAME; }).key, key = _b === void 0 ? '' : _b;
            return key;
        }
        return (_a = categoryGroupOptions.find(function (group) { return group.name === DEFAULT_CATEGORY_GROUP_NAME || group.name === DEFAULT_CATEGORY_GROUP_NAME_ALTERNATIVE; })) === null || _a === void 0 ? void 0 : _a.key;
    }
    return '';
};
export var buildColors = function () {
    var colors = [];
    for (var i = 0; i < 3; i += 1) {
        colors = __spreadArray(__spreadArray([], colors, true), [
            { color: "extended-blue-".concat(i + 2), selectedColor: "extended-blue-".concat(i + 8) },
            { color: "extended-orange-".concat(i + 2), selectedColor: "extended-orange-".concat(i + 8) },
            { color: "extended-green-".concat(i + 2), selectedColor: "extended-green-".concat(i + 8) },
            { color: "extended-yellow-".concat(i + 2), selectedColor: "extended-yellow-".concat(i + 8) },
            { color: "extended-purple-".concat(i + 2), selectedColor: "extended-purple-".concat(i + 8) },
            { color: "extended-cobalt-".concat(i + 2), selectedColor: "extended-cobalt-".concat(i + 8) },
            { color: "extended-teal-".concat(i + 2), selectedColor: "extended-teal-".concat(i + 8) },
            { color: "extended-pink-".concat(i + 2), selectedColor: "extended-pink-".concat(i + 8) },
            { color: "n".concat(i + 2), selectedColor: "n".concat(i + 8) }
        ], false);
    }
    return colors;
};
export var remapCategoryTableRows = function (categoryData, allExamsById) {
    var testedOnValues = [];
    return categoryData
        .map(function (row) {
        var categoryId = row.categoryId, subCategoryChildName = row.subCategoryChildName, subCategoryParentName = row.subCategoryParentName, meanCategoryScore = row.meanCategoryScore, totalNumberOfItems = row.totalNumberOfItems, percentStudentsBelowThreshold = row.percentStudentsBelowThreshold, totalExamBelow850 = row.totalExamBelow850, exams = row.exams, color = row.color;
        return {
            categoryId: categoryId,
            subCategoryChildName: subCategoryChildName,
            subCategoryParentName: subCategoryParentName,
            meanCategoryScore: meanCategoryScore,
            totalNumberOfItems: totalNumberOfItems,
            percentStudentsBelowThreshold: percentStudentsBelowThreshold,
            totalExamBelow850: totalExamBelow850,
            testedOn: 0,
            exams: exams,
            color: color
        };
    })
        .map(function (row, rowIndex) {
        testedOnValues[rowIndex] = 0;
        var examData = allExamsById
            .map(function (examById, index) {
            var _a, _b;
            var _c;
            var examIndex = index + 1;
            var examWithData = (_c = row.exams) === null || _c === void 0 ? void 0 : _c.find(function (exam) { return exam.examId === examById.examId; });
            if (examWithData) {
                if (examWithData.numOfItems >= 1) {
                    testedOnValues[rowIndex] += 1;
                }
                return _a = {
                        testedOn: testedOnValues[rowIndex]
                    },
                    _a["exam".concat(examIndex, "Score")] = examWithData.categoryScore,
                    _a["exam".concat(examIndex, "Total")] = examWithData.numOfItems,
                    _a;
            }
            return _b = {},
                _b["exam".concat(examIndex, "Score")] = 0,
                _b["exam".concat(examIndex, "Total")] = 0,
                _b;
        })
            .forEach(function (column) { return Object.assign(row, column); });
        return Object.assign(row, examData);
    });
};
// ================= TrendLineChart =========================
export var trendLineConfig = {
    yAxisLabel: 40,
    xAxisPadding: {
        desktop: 110,
        mobile: 60
    },
    labelLetterWidth: 7,
    xAxisAndBrushPadding: 16,
    lastDateTakenHeight: 19,
    defaultNumberOfBrushItem: {
        desktop: 5,
        ipad: 3,
        mobile: 2
    },
    heightOfOneLineExamNameInTick: 19,
    referenceLines: {
        min: 700,
        middle: 850,
        max: 1000
    },
    chartWidth: {
        mobile: 550,
        ipad: 720
    },
    dateTakenSign: '$DateTaken$',
    maxCategoryLine: 20
};
export var getSubCategoryChildNames = function (categorySummaryJoinExams) {
    return categorySummaryJoinExams.map(function (csje) { return ({
        name: csje.subCategoryChildName,
        id: csje.categoryId,
        color: csje.color
    }); });
};
export var getChartDomain = function (min, max) {
    var domainMax = max > trendLineConfig.referenceLines.max ? max : trendLineConfig.referenceLines.max;
    var domainMin = min < trendLineConfig.referenceLines.min ? min : trendLineConfig.referenceLines.min;
    var maxBufferForDisplayScore = (domainMax - domainMin) / 4;
    return {
        domainMin: Math.round(domainMin),
        domainMax: Math.round(domainMax + maxBufferForDisplayScore)
    };
};
export var initializeBrushIndex = function (chartLength, defaultNumberOfBrushItem) {
    if (defaultNumberOfBrushItem === void 0) { defaultNumberOfBrushItem = 1; }
    var numberOfBrushItem = chartLength > defaultNumberOfBrushItem ? defaultNumberOfBrushItem : chartLength;
    return { startIndex: chartLength - numberOfBrushItem, endIndex: chartLength - 1 };
};
export var getResizeScreenData = function (chartDataLength, offsetWidth) {
    var tempBrushIndex;
    var screenMode;
    var isBrushShown;
    if (offsetWidth < trendLineConfig.chartWidth.mobile) {
        tempBrushIndex = initializeBrushIndex(chartDataLength, trendLineConfig.defaultNumberOfBrushItem.mobile);
        screenMode = screenModes.mobile;
        isBrushShown = chartDataLength > trendLineConfig.defaultNumberOfBrushItem.mobile;
    }
    else if (offsetWidth < trendLineConfig.chartWidth.ipad) {
        tempBrushIndex = initializeBrushIndex(chartDataLength, trendLineConfig.defaultNumberOfBrushItem.ipad);
        screenMode = screenModes.ipad;
        isBrushShown = chartDataLength > trendLineConfig.defaultNumberOfBrushItem.ipad;
    }
    else {
        tempBrushIndex = initializeBrushIndex(chartDataLength, trendLineConfig.defaultNumberOfBrushItem.desktop);
        screenMode = screenModes.desktop;
        isBrushShown = chartDataLength > trendLineConfig.defaultNumberOfBrushItem.desktop;
    }
    var numberOfBrushItem = tempBrushIndex.endIndex - tempBrushIndex.startIndex + 1;
    var xAxisPadding = screenMode === screenModes.desktop ? trendLineConfig.xAxisPadding.desktop : trendLineConfig.xAxisPadding.mobile;
    var calculatedLabelTickWidth = (offsetWidth - xAxisPadding) / numberOfBrushItem;
    return {
        brushIndex: tempBrushIndex,
        labelTickWidth: calculatedLabelTickWidth,
        screenMode: screenMode,
        isBrushShown: isBrushShown
    };
};
export var getXAxisPadding = function (screenMode) {
    var xAxisPadding = screenMode === screenModes.mobile ? trendLineConfig.xAxisPadding.mobile : trendLineConfig.xAxisPadding.desktop;
    return {
        left: xAxisPadding + trendLineConfig.yAxisLabel,
        right: xAxisPadding
    };
};
export var calculateLabelWidth = function (letter, labelLetterWidth) { return letter * labelLetterWidth; };
export var getTrendLineChartConfig = function (maxExamNameLength, labelTickWidth) {
    var maxExamNameWidth = calculateLabelWidth(maxExamNameLength, trendLineConfig.labelLetterWidth);
    var maxExamNameNumberOfLine = Math.ceil(maxExamNameWidth / labelTickWidth);
    var xAxisHeight = trendLineConfig.xAxisAndBrushPadding * 2 + trendLineConfig.heightOfOneLineExamNameInTick * maxExamNameNumberOfLine + trendLineConfig.lastDateTakenHeight;
    var tickHeight = maxExamNameNumberOfLine * trendLineConfig.heightOfOneLineExamNameInTick + trendLineConfig.lastDateTakenHeight;
    return {
        xAxisHeight: xAxisHeight,
        tickHeight: tickHeight
    };
};
